registerComponent("pages/faq", function (component) {
/**
 * O corpo recebe o elemento raiz do componente em `component`; o build o
 * envolve em registerComponent(). Os antigos `params` viraram @props no Blade.
 *
 * Sem comportamento próprio. Em 2020 o arquivo pegava o `.iframe-faq` e tinha,
 * COMENTADO, um `load` que tentava ler a altura do documento de dentro do
 * iframe — medida que a origem cruzada do provedor de FAQ nunca permitiria. O
 * iframe fica como está (altura fixa no LESS); nada é transposto.
 */

});
